const TIME_FORMAT = 'HH:mm:ss';

export default TIME_FORMAT;
